import React from 'react'
import { PlusIcon } from '@myxplor/icons'
import { FormButton, FormDisplayErrors } from '@myxplor/forms'
import { totalTimeForDay, timeFormatted } from '../helpers'
import Session from './session'

const HoursAvailableNoAllowance = ({ hoursClaimed }) => {
  if (hoursClaimed) {
    const hoursClaimedFormatted = `You are claiming ${timeFormatted(
      hoursClaimed
    )}, but you have no available hours for this day`

    return <FormDisplayErrors errors={hoursClaimedFormatted} />
  }

  return null
}

export const SelectSessionsNoAllowance = ({
  educators = [],
  values = [],
  nameBase,
  onChange,
  addKey,
  removeKey,
  curentlyEditingSession,
  changeEditingSession,
  resetEditingSession,
}) => {
  const hoursClaimed = totalTimeForDay(values)

  if (!educators) {
    return null
  }

  return (
    <fieldset className="issCaseClaimNoAllowance">
      <div className="issCaseClaim--hoursAvailable">
        <HoursAvailableNoAllowance hoursClaimed={hoursClaimed} />
      </div>

      {values.map((educator, i) => (
        <Session
          key={i}
          onChange={onChange}
          values={educator}
          educators={educators}
          nameBase={nameBase + `[${i}]`}
          removeKey={removeKey}
          isEditing={curentlyEditingSession === i}
          changeEditingSession={() => changeEditingSession(i)}
          resetEditingSession={resetEditingSession}
          isOverTime
        />
      ))}

      <FormButton
        center
        onClick={() => {
          changeEditingSession(values.length)
          addKey(nameBase, {
            hours: '1',
            minutes: '00',
            personnel_id: educators[0].id,
          })
        }}>
        <PlusIcon title="Add a educator" />
      </FormButton>
    </fieldset>
  )
}

export default SelectSessionsNoAllowance



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/select-session/no-allowance.jsx